export default __webpack_public_path__ + "static/media/LO02.90cbde18.mp3";